import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchUserTicketsApi } from '../services/tickets'

const getUserId = (state) => {
  const id = state.auth?.userData?.id
  if (id) return id
  try {
    const token = localStorage.getItem('access_token')
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]))
      return payload.sub || payload.id || payload.user_id || null
    }
  } catch (e) {}
  return null
}

export const fetchUserTickets = createAsyncThunk(
  'userTickets/fetchUserTickets',
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState()
      const userId = getUserId(state)
      if (!userId) return thunkAPI.rejectWithValue('SESSION_EXPIRED')
      return await fetchUserTicketsApi({ userId, limit: 20 })
    } catch (err) {
      return thunkAPI.rejectWithValue(err.type || err.message || 'Error desconocido')
    }
  }
)

export const loadMoreUserTickets = createAsyncThunk(
  'userTickets/loadMoreUserTickets',
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState()
      const userId = getUserId(state)
      const { nextCursor } = state.userTickets
      if (!userId) return thunkAPI.rejectWithValue('SESSION_EXPIRED')
      return await fetchUserTicketsApi({ userId, cursor: nextCursor, limit: 20 })
    } catch (err) {
      return thunkAPI.rejectWithValue(err.type || err.message || 'Error desconocido')
    }
  }
)

const initialState = {
  tickets: [],
  nextCursor: null,
  hasMore: false,
  loading: false,
  loadingMore: false,
  error: null
}

const userTicketsSlice = createSlice({
  name: 'userTickets',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    resetList: (state) => {
      state.tickets = []
      state.nextCursor = null
      state.hasMore = false
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserTickets.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUserTickets.fulfilled, (state, action) => {
        state.loading = false
        state.tickets = action.payload.tickets || []
        state.nextCursor = action.payload.nextCursor || null
        state.hasMore = action.payload.hasMore || false
      })
      .addCase(fetchUserTickets.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Error desconocido'
      })
      .addCase(loadMoreUserTickets.pending, (state) => {
        state.loadingMore = true
        state.error = null
      })
      .addCase(loadMoreUserTickets.fulfilled, (state, action) => {
        state.loadingMore = false
        state.tickets = [...state.tickets, ...(action.payload.tickets || [])]
        state.nextCursor = action.payload.nextCursor || null
        state.hasMore = action.payload.hasMore || false
      })
      .addCase(loadMoreUserTickets.rejected, (state, action) => {
        state.loadingMore = false
        state.error = action.payload || 'Error desconocido'
      })
  }
})

export const { clearError, resetList } = userTicketsSlice.actions

export const selectUserTickets = (state) => state.userTickets.tickets
export const selectUserTicketsNextCursor = (state) => state.userTickets.nextCursor
export const selectUserTicketsHasMore = (state) => state.userTickets.hasMore
export const selectUserTicketsLoading = (state) => state.userTickets.loading
export const selectUserTicketsLoadingMore = (state) => state.userTickets.loadingMore
export const selectUserTicketsError = (state) => state.userTickets.error

export default userTicketsSlice.reducer
